export var getDisplayName = function getDisplayName(component) {
    return component.displayName || component.name || 'Component';
};

export var ifNot = function ifNot(condition, errorMessage) {
    if (!condition) throw new Error(errorMessage);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router5/dist/es/utils.js
// module id = 138
// module chunks = 0